import { createElement as domCreateElement } from '../../../../core/utils/dom.js';
import { getCurrentLanguage, interpolate } from '../../../translations.js';
import { fetchCharacterSpriteUrl } from '../character-manager.js';

export const createElement = (tag, className = '', attributes = {}) =>
    domCreateElement(tag, { ...attributes, className });

export const getSettingsModalTranslationText = (key, fallback = '') => {
    const language = getCurrentLanguage();
    const fromLanguage = window.translations?.[language]?.hangout?.settings_modal?.[key];
    const fromEnglish = window.translations?.en?.hangout?.settings_modal?.[key];
    return fromLanguage ?? fromEnglish ?? fallback;
};

export function updatePreview(previewId, imageUrl) {
    const preview = document.getElementById(previewId);
    if (!preview) return;

    preview.replaceChildren();
    if (!imageUrl) {
        const empty = createElement('div', 'settings-preview-empty', {
            textContent: getSettingsModalTranslationText('no_preview_available', 'No preview available')
        });
        preview.appendChild(empty);
        return;
    }
    const img = createElement('img', 'settings-preview-img', {
        src: imageUrl,
        alt: 'Character preview'
    });
    img.draggable = false;
    preview.appendChild(img);
}

export function setPreviewLocked(previewId, isLocked) {
    const badge = document.getElementById(`${previewId}-lock-badge`);
    if (!badge) return;

    const locked = isLocked === true;
    badge.classList.toggle('is-visible', locked);
    badge.setAttribute('aria-hidden', locked ? 'false' : 'true');
}

export async function showError(message, previewId) {
    const { showError: showUnifiedError } = await import('../../../utils/UnifiedNotificationSystem.js');
    const preview = document.getElementById(previewId);

    showUnifiedError(message, {
        relativeTo: preview || document.body,
        position: 'center',
        duration: 4000
    });
}

export async function fetchSprite(characterId, outfitId, previewId) {
    try {
        const spriteUrl = await fetchCharacterSpriteUrl(characterId, 2016, outfitId);
        updatePreview(previewId, spriteUrl);
        return spriteUrl;
    } catch (error) {
        console.error('Failed to fetch sprite:', error);
        await showError(getSettingsModalTranslationText('failed_load_character_preview', 'Failed to load character preview'), previewId);
        return null;
    }
}

export async function getTranslation(key, replacements = {}) {
    const { loadTranslations } = await import('../../../translations.js');
    const lang = getCurrentLanguage();
    await loadTranslations('hangout', lang).catch(() => {});

    const translations = window.translations?.[lang]?.hangout || window.translations?.en?.hangout || {};
    const keys = key.split('.');
    let value = translations;
    for (const k of keys) {
        value = value?.[k];
        if (value === undefined) break;
    }

    if (value === undefined) {
        console.warn(`Translation missing for key: ${key} (lang: ${lang})`);
        return key.split('.').pop();
    }

    return interpolate(value, replacements);
}
